/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'
import { extrudeSettings } from '../../../../../../utils/Functions';
import { params } from '../../../../../../redux/reducers/reducer';
import WindowModel from './WindowModel';
import PatternOneModel from '../../../ShareModel/PatternModel/PatternOneModel';
import HandleOneModel from '../../../ShareModel/HandleModel/HandleOneModel';

const ElevenLiteWalkInDoor = ({ width, height, trimWidth, doorColor, isOverlap, overlapTrimColor, glassTexture, handleModel }) => {
    const trimColor = useMemo(() => {

        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])
    
    const doorWidth = width - trimWidth * 2
    const doorHeight = height - trimWidth    
    const unitCountX = 20;
    const unitCountY = 30;
    const unitWidth = doorWidth / unitCountX;
    const unitHeight = doorHeight / unitCountY;
    const marginX = unitWidth * 2.5;
    const holeDistanceX = unitWidth * 3
    const holeWidth = (doorWidth - marginX * 2 - holeDistanceX) / 2;    
    const marginY = unitHeight * 2
    const holeDistanceY = unitHeight * 2.5
    const smallHoleHeight = (doorHeight - marginY * 2 - holeDistanceY * 2) / 7
    const largeHoleHeight = smallHoleHeight * 3
    const windowWidth = doorWidth - marginX * 2;
    const windowHeight = doorHeight - marginY * 2 - holeDistanceY - largeHoleHeight;
    const windowRoundPartHandleHeight = windowHeight / 3;
    
    const trimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth,  -height / 2);
        model.lineTo(-width / 2,  -height / 2);
        model.lineTo(-width / 2,  height / 2);
        model.lineTo(width / 2,  height / 2);
        model.lineTo(width / 2,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  height / 2 - trimWidth);
        model.lineTo(-width / 2 + trimWidth,  height / 2 - trimWidth);
        model.closePath();
        
        return model
    }, [width, height, trimWidth])

    const doorModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(width / 2 - 0.03) + trimWidth,  (height / 2 - 0.03) - trimWidth);
        model.lineTo(-(width / 2 - 0.03) + trimWidth,  -(height / 2 - 0.03));
        model.lineTo((width / 2 - 0.03) - trimWidth,  -(height / 2 - 0.03));
        model.lineTo((width / 2 - 0.03) - trimWidth,  (height / 2 - 0.03) - trimWidth);
        
        const holeWindow = new THREE.Path();
        holeWindow.moveTo(-windowWidth / 2, height / 2 - trimWidth - marginY - windowHeight);
        holeWindow.lineTo(-windowWidth / 2, height / 2 - trimWidth - marginY - windowRoundPartHandleHeight);
        holeWindow.quadraticCurveTo(
                -windowWidth / 2.5, height / 2 - trimWidth - marginY,
                0, height / 2 - trimWidth - marginY
            );
        holeWindow.quadraticCurveTo(
                windowWidth / 2.5, height / 2 - trimWidth - marginY,
                windowWidth / 2, height / 2 - trimWidth - marginY - windowRoundPartHandleHeight
            );
        holeWindow.lineTo(windowWidth / 2, height / 2 - trimWidth - marginY - windowHeight);
        holeWindow.closePath();

        model.holes.push(holeWindow);

        for (let i = 0; i < 2; i ++) {
            const hole_under = new THREE.Path();
            hole_under.moveTo(Math.pow(-1, i) * (holeDistanceX / 2), -height / 2 + marginY);
            hole_under.lineTo(Math.pow(-1, i) * (holeDistanceX / 2), -height / 2 + marginY + largeHoleHeight);
            hole_under.lineTo(Math.pow(-1, i) * (holeDistanceX / 2 + holeWidth), -height / 2 + marginY + largeHoleHeight);
            hole_under.lineTo(Math.pow(-1, i) * (holeDistanceX / 2 + holeWidth), -height / 2 + marginY);
            hole_under.closePath();

            model.holes.push(hole_under);
        }

        return model;
    
    }, [width, height, trimWidth])

    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[trimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={isOverlap ? overlapTrimColor : trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            <mesh name='door' position={[0, 0, 0.05]}>
                <extrudeGeometry args={[doorModel, extrudeSettings(0.2, 0.03, 0.03, 0, 2)]} />
                <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
            </mesh>

            <group position={[0, height / 2 - trimWidth - marginY - windowHeight / 2, 0]}>
                <WindowModel windowWidth={windowWidth} windowHeight={windowHeight} doorColor={doorColor} glassTexture={glassTexture}  />
            </group>

            <HandleOneModel width={width}  handleModel={handleModel} />

            {new Array(2).fill("").map((_, index) => 
                <group key={`pattern-model-${index}`} position={[Math.pow(-1, index) * (holeDistanceX / 2 + holeWidth / 2), 0, 0]}>
                    <group name='under' position={[0, -height / 2 + marginY + largeHoleHeight / 2, 0]}>
                        <PatternOneModel modelWidth={holeWidth} modelHeight={largeHoleHeight} doorColor={doorColor}  />
                    </group>
                </group>
            )}
        </>
    )
}

export default ElevenLiteWalkInDoor